import { useContext } from 'react';
import { GroupsContext } from './GroupsProvider';
import { ProjectsContext } from './ProjectsProvider';
import { UsersContext } from './UsersProvider';

export function useGroupsContext() {
  const context = useContext(GroupsContext);

  if (!context) {
    throw new Error(
      'The Groups Context must be used within an GroupsContextProvider',
    );
  }

  return context;
}

export function useUsersContext() {
  const context = useContext(UsersContext);

  if (!context) {
    throw new Error(
      'The Users Context must be used within an UsersContextProvider',
    );
  }

  return context;
}

export function useProjectsContext() {
  const context = useContext(ProjectsContext);

  if (!context) {
    throw new Error(
      'The Projects Context must be used within an ProjectsContextProvider',
    );
  }

  return context;
}
